import React from "react";

import styles from "./styles.css";

const defaultDictionary = {
	title: "The new record was created, but the form object(s) with the following labels could not be copied successfully to the new record due to form incompatibilities:",
	description:  "Potential incompatibilities could be that the form object types are not the same, the available answer selections are not the same, or some other object configuration is not the same that prevents the answer from being populated into the new record.\n" +
                  "The list of short labels should be provided to a system admin so they can investigate and update the forms to address these incompatibilities.",
};

export const IncompatibleWarning = ({ elements }) => {
	return (
		<React.Fragment>
			<h4 className={styles.title}>
				{defaultDictionary.title}
			</h4>
			<ul className={styles.list}>
				{elements.map((elements, k) => (
					<li key={k}>
						<p>
							{elements.label}
						</p>
					</li>
				))}
			</ul>
			<h5 className={styles.title}>
				{defaultDictionary.description}
			</h5>
		</React.Fragment>
	);
};